import { Flex, Loader, LoaderProps } from '@mantine/core';

interface CustomSpinnerProps extends LoaderProps {
  animationDuration?: string;
}

export default function CustomSpinner({
  size = 'xl',
  animationDuration = '1.0s',
}: CustomSpinnerProps) {
  return (
    <Flex style={{ height: '100%', width: '100%' }} justify="center" align="center">
      <Loader size={size} style={{ animationDuration }} />
    </Flex>
  );
}
